// Vue, Vue module
import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

// Routes
import AboutRoutes from './about'
import AccountRoutes from './account'
import BuyRoutes from './buy'
import ErrorRoutes from './error'
import MyPageRoutes from './mypage'
import ProductRoutes from './product'
import PromotionRoutes from './promotion'
import SupportRoutes from './support'
import TermsRoutes from './terms'
//import ThemeRoutes from './theme'

// Config
const { initials, languages } = require('~/config')

// Import methods
import { layouts, pages } from '../util/global-methods'

// Set Vue Router
Vue.use(Router)
Vue.use(Meta)

const defaultRoutes = [
  { path: '', component: pages('mainpage'), props: true, meta: { store: 'main' }, name: 'main' },
  ...AccountRoutes,
  ...BuyRoutes,
  ...ProductRoutes,
  ...PromotionRoutes,
  ...SupportRoutes,
  ...MyPageRoutes,
  ...TermsRoutes,
  ...AboutRoutes,
  ...ErrorRoutes,
]

const children = [...defaultRoutes]

export function createRouter() {
  return new Router({
    mode: 'history',

    scrollBehavior: (to, from, savedPosition) => {
      if (savedPosition) {
        return savedPosition
      } else if (to.params.initScroll) {
        return { y: 0 }
      } else if (to.params.listTop) {
        return { selector: 'list' }
      } else if (to.hash) {
        return { selector: to.hash }
      } else if (to.name == from.name && !!to.name) {
        return
      } else if (to.path && from.path && to.path !== from.path) {
        return { y: 0 }
      }
    },

    routes: [
      { path: '/', name: 'home', redirect: '/' + initials.fallbackLocale },
      {
        path: '/icons',
        component: pages('_dev/icons.vue'),
        meta: { layout: 'clean' },
        props: true,
      },
      {
        path: '/style-guide',
        component: pages('_dev/style-guide.vue'),
        meta: { layout: 'clean' },
        props: true,
      },
      { path: '/login-social', component: layouts('social'), props: true },
      // {path: '/sign-up-social', component: layouts('social'), props: true},
      {
        path: `/:langCode(${languages.join('|')})`,
        component: layouts('root'),
        props: true,
        children: children,
      },
      //{path: '/:pageName+', component: pages('error/404'), props: true, meta: {layout: 'clean'}}
    ],
  })
}
